export default "__VITE_ASSET__CjA4BjaA__"